import { NgModule } from '@angular/core';
import { UiModule } from './../../../../ui/ui.module';
import { OfferCalculatorDetailsTableComponent } from './offer-calculator-details-table.component';

@NgModule({
	imports: [
		UiModule,
	],
	declarations: [
		OfferCalculatorDetailsTableComponent
	],
	exports: [
		OfferCalculatorDetailsTableComponent
	],
})
export class OfferCalculatorDetailsTableModule { }
